import type { Evaluation } from './evaluation.type.ts';
export interface EvaluationExtension extends Evaluation {}
export class EvaluationExtension {
  get agreementLabel() {
    return this.agreement?.replace('EvaluationAgreement.', '') ?? '';
  }

  get isAgreed() {
    return this.agreement === 'EvaluationAgreement.AGREED';
  }

  get isDisagreed() {
    return this.agreement === 'EvaluationAgreement.DISAGREED';
  }

  get hasNoRecommendation() {
    return this.agreement === 'EvaluationAgreement.NO_RECOMMENDATION';
  }

  get agreementIntent() {
    if (this.isAgreed) return 'success';
    if (this.isDisagreed) return 'danger';
    return 'default';
  }
}

const Registration = {
  kind: 'object',
  name: 'evaluation',
  features: EvaluationExtension,
};
export default Registration;
